module.exports = __webpack_public_path__ + "img/fi-rr-megaphone.4d634dda.svg";